import { Tooltip as MantineTooltip, type TooltipFactory } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import styles from "./tooltip.module.scss";
import type { IProps } from "./tooltip.types";

const Tooltip = componentWrapper<TooltipFactory, IProps>("Tooltip", (props, ref) => {
    return (
        <MantineTooltip
            p="md"
            bdrs="md"
            maw={540}
            withArrow
            arrowSize={9}
            ref={ref}
            classNames={{ tooltip: styles["container"] }}
            {...props}
        />
    );
});

Tooltip.Floating = MantineTooltip.Floating;
Tooltip.Group = MantineTooltip.Group;

export { Tooltip };
